import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createUser, getUser, getUserByUPN, getUserCostCenter, getUserDivisions, getUserGridData, setUserByUPN, updateUser } from "redux/UserManagement/action";
import selectors from "redux/UserManagement/selectors";
import AddEditUser from "./AddEditUser";
import confirmation from "../../../../../../client/assets/images/ConfirmationBee.svg";
import successIcon from "../../../../../assets/images/SuccessBee.svg";
import { PivotItem } from "@fluentui/react";
import userManageOperations from '../../../../../../redux/UserManagement/operations'
import { popupInitialData } from "utils";
import { commonPopupDisplay } from "client/Components/Administraton/utils/AdministrationUtils";

type IProps = {
  selectedUserId: any;
  setSelectedUser?: any;
};

const AddEditUserContainer = ({ selectedUserId, setSelectedUser }: IProps) => {
  const initialValues = {
    firstName: "",
    lastName: "",
    jobTitle: "",
    employeeId: "",
    adUserId: "",
    companyId: null,
    email: "",
    emailNotification: true,
    extn: '',
    fax: "",
    costCenter: "",
    isActive: true,
    mobile: '',
    phone: '',
    sId: "",
    timeZoneId: null,
    userId: 0,
  };
  const [userForm, setUserForm] = useState<any>(initialValues);
  const initialError = {
    firstNameError: "",
    lastNameError: "",
    employeeIdError: "",
    emailError: "",
    companyIdError: "",
    costCenterError: "",
  };
  const { userData, userUpnData, divisionDropdown, costcenterDropdown, addUserVal, checkUser, isCheck, isUserCheck } = useSelector((state: any) => ({
    userData: selectors.getUser(state),
    userUpnData: selectors.getUserUpnData(state) as any,
    divisionDropdown: selectors.getUserDivisions(state) as any,
    costcenterDropdown: selectors.costcenterDropdown(state) as any,
    addUserVal: state.UserManagement.addUserVal,
    checkUser: state.UserManagement.checkUser,
    isUserCheck: state.UserManagement.isUserCheck,
    isCheck: state.UserManagement.isCheck
  }))

  const dispatch = useDispatch();
  const CheckUser = userManageOperations.dispatchGetCheckUser(dispatch)
  const [userFormError, setUserFormError] = useState<any>(initialError);
  const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);
  const [selectedKey, setSelectedKey] = React.useState<string>("app-listing");
  const [isAdding, setIsAdding] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [tabChange, setTabChange] = useState(false);
  const [dataVal, setDataVal] = useState<any>([])

  useEffect(() => {
    if (selectedUserId) {
      dispatch(getUser(selectedUserId));
    }
    dispatch(setUserByUPN({}))
    dispatch(getUserDivisions())
  }, []);

  useEffect(() => {
    if (userData && selectedUserId) {
      setUserForm(userData);
    }
  }, [userData])
  useEffect(() => {
    if (userUpnData && userUpnData.accountEnabled) {
      const userData = userUpnData.userDetails;
      setUserForm({
        ...userForm,
        firstName: userData.firstName,
        lastName: userData.lastName,
        middleName: userData.middleName,
        email: userData.email,
      });
      setUserFormError({
        ...userFormError,
        emailError: ""
      })
    }
    else if (Object.keys(userUpnData).length && !userUpnData?.accountEnabled) {
      setUserFormError({
        ...userFormError,
        emailError: "Please Enter valid UPN"
      })
    }
  }, [userUpnData])

  const hideDialog = () => {
    setPopupcontent({ ...Popupcontent, isDialogVisible: false });
  }

  const handleLinkClick = (item?: PivotItem) => {
    if (selectedUserId !== "" || addUserVal !== 0 || item?.props?.itemKey == "General") {
      if (item) {
        setSelectedKey(item.props.itemKey!);
      }
    } else {
      let message : any = "Kindly save user general information to assign the security role or security permission."
        commonPopupDisplay(message, setPopupcontent, Popupcontent, confirmation, "Information", handleInfoPopup)
      setTabChange(true);
    }

  };
  const handleInfoPopup = () => {
    hideDialog()
    setTabChange(false);
  }

  const handleClickPopup = () => {
    hideDialog();
    setUserFormError(initialError)
    dispatch(getUserGridData({ columnFilters: [], pageNumber: 1, pageSize: 10}))
  }
  const handleFailurePopup = () => {
    hideDialog()
  }

  const validation: any = (name: any, value: any) => {
    let error = { ...userFormError };
    switch (name) {
      case "firstName":
        if (value === undefined || value === "" || value === null) {
          error.firstNameError = "Please enter First Name";
        } else {
          error.firstNameError = "";
        }
        break;
      case "lastName":
        if (value === undefined || value === "" || value === null) {
          error.lastNameError = "Please enter Last Name";
        } else {
          error.lastNameError = "";
        }
        break;
      case "employeeId":
        if (value === undefined || value === "" || value === null) {
          error.employeeIdError = "Please enter Employee Id";
        } else {
          error.employeeIdError = "";
        }
        break;
      case "email":
        if (value === undefined || value === "" || value === null || !userUpnData?.accountEnabled) {
          error.emailError = "Please Enter Valid UPN";
        } else {
          error.emailError = "";
        }
        break;
      case "companyId":
        if (value === undefined || value === "" || value === null) {
          error.companyIdError = "Please select Default Company";
        } else {
          error.companyIdError = "";
        }
        break;
      case "costCenter":
        if (value === undefined || value === "" || value === null) {
          error.costCenterError = "Please select Home Cost Center";
        } else {
          error.costCenterError = "";
        }
        break;
    }
    return error;
  };

  const fetchUserByUpn = async () => {
    if (userForm.email) {
      dispatch(getUserByUPN(userForm.email));
    }
  }

  const userHandleChange = (e?: any, item?: any) => {

    let { name, value } = e.target;
    value = item;
    name = e.target.getAttribute("name");
    if (
      name === "costCenter" ||
      name === "timeZoneId"
    ) {
      setUserForm({ ...userForm, [name]: value.key });
    } else if (name === "companyId") {
      dispatch(getUserCostCenter(value.key));
      setUserForm({ ...userForm, [name]: parseInt(value.key) });
    } else {
      setUserForm({ ...userForm, [name]: value });
    }
    let formValidationError: any = {};

    let formValidation = validation(name, value);
    formValidationError[name + "Error"] = formValidation[name + "Error"];
    setUserFormError({
      ...userFormError,
      [name + "Error"]: formValidation[name + "Error"],
    });
  };

  const handleClickSave = () => {

    setIsSubmitted(true)
    let valid = true;
    let formValError: any = {};
    for (let key in userForm) {
      let formVal = validation(key, userForm[key]);
      formValError[key + "Error"] = formVal[key + "Error"];
      if (formVal[key + "Error"]) {
        valid = false;
      }
    }
    fetchUserByUpn()
    setUserFormError({ ...formValError });
    if (valid) {
      const userData = {
        ...userForm,
        adUserId: userForm.firstName + userForm.lastName,
      };
      setDataVal(userData)
      dispatch(CheckUser(userData))
    }
  };
  useEffect(() => {
    if (userForm.companyId && userForm.userId) {
      dispatch(getUserCostCenter(userForm.companyId))
    }
  }, [userForm])
  useEffect(() => {
    if ((checkUser.hasOwnProperty("data") ? !checkUser.data : !checkUser) && dataVal.firstName) {
      if (selectedUserId) {
        dispatch(updateUser(dataVal));
      } else {
        dispatch(createUser(dataVal));
      }
      setDataVal([initialValues])
      setIsAdding(true)
    }
    else if ((checkUser.hasOwnProperty("data") ? checkUser.data : checkUser) && isSubmitted) {
      let message : any =  checkUser.msg
        commonPopupDisplay(message, setPopupcontent, Popupcontent, confirmation, "Failed", handleFailurePopup)
      setIsSubmitted(false)
    }
  }, [checkUser, isCheck])
  useEffect(() => {
    if (addUserVal != undefined && addUserVal != 0 && isSubmitted) {
      if (addUserVal > 0 && (checkUser.hasOwnProperty("data") ? !checkUser.data : !checkUser)) {
        let message : any = ""
       if((userForm.userId != 0)){
         message = "User has been updated successfully"
       }else{
        message = `User has been created successfully with id ` + addUserVal
       }
        commonPopupDisplay(message, setPopupcontent, Popupcontent, successIcon, "Success", handleClickPopup)
      }
      else if ((selectedUserId < 1 || selectedUserId == "") && (addUserVal == 0 || addUserVal == "error") && tabChange) {
        let message : any = "Kindly save user general information to assign the security role or security permission."
        commonPopupDisplay(message, setPopupcontent, Popupcontent, confirmation, "Information", handleInfoPopup)
      }
      else if (((checkUser.hasOwnProperty("data") ? checkUser.data : checkUser) && addUserVal == 0 && isUserCheck) || (addUserVal == "error")) {
        let message : any = []
        if(addUserVal == "error"){
          message = "Error Occured while processing the request."
        }else{
          message = checkUser.msg
        }
        commonPopupDisplay(message, setPopupcontent, Popupcontent, confirmation, "Failed", handleFailurePopup)
      }
      setIsSubmitted(false)
      setIsAdding(false)
    }
  }, [addUserVal, isAdding])

  return (
    <AddEditUser
      userHandleChange={userHandleChange}
      handleClickSave={handleClickSave}
      userFormError={userFormError}
      userForm={userForm}
      selectedUserId={selectedUserId}
      fetchUserByUpn={fetchUserByUpn}
      handleLinkClick={handleLinkClick}
      selectedKey={selectedKey}
      divisionData={divisionDropdown}
      costcenterDropdown={costcenterDropdown}
      setUserForm={setUserForm}
      initialValues={initialValues}
      setUserFormError={setUserFormError}
      initialError={initialError}
      Popupcontent = {Popupcontent}
    />
  );
};

export default AddEditUserContainer;
